import FileAnalysisStore from 'stores/FileAnalysisStore';
import FileStore from 'stores/file/FileStore';

export default class FileListStore extends FileAnalysisStore<FileStore> {
    constructor() {
        super({
            itemStore: FileStore,
            baseRoute: 'fileRepLocals'
        });
    }
}
